import React from "react";
import { Helmet } from "react-helmet";
import { IS_ADWILE } from "../constants/cabinet";

const AdwileHead = () => {
  return (
    <Helmet>
      <title>ADWILE | Кабинет</title>
      <meta name="description" content="Кабинет рекламодателей" />
      <link rel="shortcut icon" href="/app/adwile/favicon.ico" />
    </Helmet>
  );
};

const Head = () => {
  return !IS_ADWILE ? null : <AdwileHead />;
};

export default Head;
